import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

import ProductDetailHero from "../components/productDetails/ProductDetailHero";
 
import { Header, Footer } from "../shared";

import { productSeo } from "../seo/productSeo";

const ProductDetail = () => {
  const { id } = useParams();

  const seo = productSeo[id];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {seo && (
        <Helmet>
          {/* Title */}
          <title>{seo.title}</title>

          {/* Meta Description */}
          <meta
            name="description"
            content={seo.description}
          />

          {/* Canonical */}
          <link
            rel="canonical"
            href={seo.canonical}
          />

          {/* Open Graph */}
          <meta property="og:type" content="product" />

          <meta
            property="og:title"
            content={seo.title}
          />

          <meta
            property="og:description"
            content={seo.description}
          />

          <meta
            property="og:url"
            content={seo.canonical}
          />

          <meta
            property="og:image"
            content={seo.schema.image}
          />

          {/* Twitter */}
          <meta
            name="twitter:card"
            content="summary_large_image"
          />

          <meta
            name="twitter:title"
            content={seo.title}
          />

          <meta
            name="twitter:description"
            content={seo.description}
          />

          <meta
            name="twitter:image"
            content={seo.schema.image}
          />

          {/* Product Schema */}
          <script type="application/ld+json">
            {JSON.stringify(seo.schema)}
          </script>
        </Helmet>
      )}

      <div>
        <div className="bg_darkblue">
          <Header />
        </div>

        <ProductDetailHero />

        <Footer />
      </div>
    </>
  );
};

export default ProductDetail;